export enum PartnerType {
    SE = 'Self Employed',
    IE = 'Individual Entrepreneur',
    LLC = 'Limited Liability Company',
}

export enum FormTypeEnum {
    INDIVIDUAL = 'individual',
    SELF_EMPLOYED = 'self_employed',
    LEGAL_ENTITY = 'legal_entity',
}

export enum FnsStatusEnum {
    UNREGISTERED = 'UNREGISTERED',
    UNBOUND = 'UNBOUND',
    BOUND = 'BOUND',
}

export enum DocumentTypeEnum {
    CHARTER = 6,
    POWER_OF_ATTORNEY = 7,
    REGISTRATION_CERTIFICATE = 11,
}

export enum SignupExternalStateEnum {
    TYPE = 'type',
    SELF_EMPLOYED = 'self_employed',
    BANK = 'bank',
    SIGNER = 'signer',
    SUBMIT = 'submit',
    COMPLETE = 'complete',
}

export enum PartnerRegistrationErrorEnum {
    UNREGISTERED = 'UNREGISTERED',
    NOT_BOUND = 'NOT_BOUND',
}

export interface SignupExternalStepCommon {
    disabled_fields: string[];
    is_partially_filled: boolean;
    next_state?: SignupExternalStateEnum;
    previous_state?: SignupExternalStateEnum;
}

export interface SignupExternalPersonal extends SignupExternalStepCommon {
    first_name: string;
    last_name: string;
    patronym?: string;
    birth_date: string;
    pass_number: string;
    issue_date: string;
    issuer_code: string;
    issued_by: string;
    legal_address: string;
    legal_address_postcode?: string;
    snils: string;
    inn: string;
}

export interface SignupExternalLegalEntity extends SignupExternalStepCommon {
    legal_form: number;
    vat_rate: number;
    business_name: string;
    ogrn_or_inn: string;
    legal_address?: string;
    legal_address_postcode?: string;
}

export interface SignupExternalPartnership extends SignupExternalStepCommon {
    country: number;
    form_type: FormTypeEnum;
    country_selected: boolean;
    personal_data?: SignupExternalPersonal;
    legal_data?: SignupExternalLegalEntity;
}

export interface SignupExternalSelfEmployed extends SignupExternalStepCommon {
    fns_status: FnsStatusEnum;
}

export interface SignupExternalBank extends SignupExternalStepCommon {
    bic: string;
    account_nr: string;
    bank_name: string;
    correspondent_account_nr: string;
    actual_address_same?: boolean;
    actual_address?: string;
    actual_address_postcode?: string;
}

export interface SignupExternalSigner extends SignupExternalStepCommon {
    position: string;
    full_name: string;
    document_type: DocumentTypeEnum;
    document_scan_key: number | null;
}

export interface BankInfo {
    bic: string;
    name: string | null;
    city: string | null;
    city_prefix: number | null;
    correspondent_account: string | null;
}

export interface SignupExternalState {
    state: SignupExternalStateEnum;
    is_closed: boolean;
}

export interface SERegistrationModel {
    type: PartnerType.SE;
    birthDate: string;
    firstName: string;
    index: string;
    issuedBy: string;
    issuedDate: string;
    lastName: string;
    passport: string;
    patronymic: string;
    registrationAddress: string;
    snilsNumber: string;
    subdivisionCode: string;
    subdivisionName: string;
}

export interface IERegistrationModel {
    type: PartnerType.IE;
    registrationAddress: string;
    index: string;
    innOgrn: string;
    snilsNumber: string;
}

export interface LLCRegistrationModel {
    type: PartnerType.LLC;
    name: string;
    innOgrn: string;
}

export type PartnerRegistrationModel =
    | SERegistrationModel
    | IERegistrationModel
    | LLCRegistrationModel;

export interface PartnerBankDetailsModel {
    bik: string;
    bankName: string;
    accountNumber: string;
}

export interface PartnerSignerDataModel {
    fullName: string;
    position: string;
}
